const AlertBox = (props) => {
    return (
        <div className={`alert_box ${props.type} ${props.className}`}>{props.children}</div>
    );
}

export default AlertBox;